import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const WHATSAPP_NUMBER = '50379473074';
const WHATSAPP_MESSAGE = encodeURIComponent('Hola, tengo una consulta sobre mi importación con EARIA.');
export function WhatsAppBubble() {
  return <motion.a href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-40 flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg shadow-green-500/30 transition-colors group" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 0.5,
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} title="Chatea con nosotros por WhatsApp" data-id="element-423">
      {/* Expanded label on hover (desktop) */}
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold group-hover:max-w-[200px] group-hover:pl-5 transition-all duration-300 ease-in-out" data-id="element-424">
        ¿Necesitas ayuda?
      </span>
      <div className="w-14 h-14 flex items-center justify-center" data-id="element-425">
        <MessageCircle className="w-7 h-7" fill="white" strokeWidth={0} data-id="element-426" />
      </div>
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-20 pointer-events-none" data-id="element-427" />
    </motion.a>;
}